import component from './PhArrowULeftUp.vue_vue_type_script_lang.vue.js';
export { default } from './PhArrowULeftUp.vue_vue_type_script_lang.vue.js';
import { render } from './PhArrowULeftUp.vue_vue_type_template_id_6a99f0c0_lang.vue.js';

component.render = render;
